import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    cargos: [],
    /* Info de paginación */
    paginaActual: 1,
    totalPaginas: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    /* Filtro */
    nombre: '',
    incluirInactivos: false,
    nombreBusqueda: '',

    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.cargos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
        state.nombreBusqueda = '';
    },

    'INICIALIZAR' (state) {
        state.cargos = [];
    },
    'SET_CARGOS' (state, cargos) {
        state.cargos = cargos;
    },
    'SET_FILTERED_PAGINATION' (state, params) {
        state.paginaActual = params.paginaActual;
        state.totalRegistros = params.totalRegistros;
    },
    'SET_PAGINATION' (state, params) {
        state.paginaActual = params.paginaActual;
        state.totalPaginas = params.totalPaginas;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
    },

    'INICIALIZAR_LIST' (state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, params) {
        state.list = params.list;
        state.selectList = params.selectList;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getCargos: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit ('INICIALIZAR');

            let queryString = '';
        
            if (state.nombre) {
                if (queryString == '') {
                    queryString = '?nombre=' + state.nombre;
                } else {
                    queryString += '&nombre=' + state.nombre;
                }
            }
            
            if ((/true/i).test(state.incluirInactivos)) {
                if (queryString == '') {
                    queryString = '?incluirInactivos=true';
                } else {
                    queryString += '&incluirInactivos=true';
                }
            }            
              
            apiAxios.get('cargos' + queryString)
            .then(res => {
                /*
                if (res.headers.pagination){
                    const pagination= JSON.parse(res.headers.pagination)
                    var params= {
                        paginaActual: pagination.currentPage,
                        registrosPorPagina: pagination.itemsPerPage,
                        totalRegistros: pagination.totalItems,
                        totalPaginas: pagination.totalPages
                    }
                    commit ('SET_PAGINATION', params);
                }
                */
                let params = {
                    paginaActual: 1,
                    totalRegistros: res.data.length
                }
                commit ('SET_FILTERED_PAGINATION', params);
            
                commit ('SET_CARGOS', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('cargos/list')
                .then(res => {
                    let selectList = [];
                    res.data.forEach( cargo => selectList.push(cargo.nombre.trim()) );

                    let params = {
                        list: res.data,
                        selectList
                    }

                    commit('SET_LIST', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,
    
    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}